if (!customElements.get('bagera-product')) {
  customElements.define('bagera-product', class BageraProduct extends HTMLElement {
    constructor() {
      super();
      this.offer = 'bag';
      this.offerButtons = Array.from(this.querySelectorAll('[data-bagera-offer]'));
      this.forms = Array.from(this.querySelectorAll('[data-bagera-product-form]'));
      this.price = this.querySelector('[data-bagera-price]');
      this.compare = this.querySelector('[data-bagera-compare]');
      this.saving = this.querySelector('[data-bagera-saving]');
      this.stickyPrice = this.querySelector('[data-bagera-sticky-price]');
      this.stickyDetail = this.querySelector('[data-bagera-sticky-detail]');
      this.sticky = this.querySelector('[data-bagera-sticky]');
      this.gallery = this.querySelector('[data-bagera-gallery]');
      this.dots = Array.from(this.querySelectorAll('[data-bagera-dot]'));
      this.bind();
      this.selectOffer('bag');
    }

    bind() {
      this.offerButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectOffer(button.dataset.bageraOffer));
      });

      this.querySelectorAll('[data-bagera-variant]').forEach((select) => {
        select.addEventListener('change', () => this.selectVariant(select));
      });

      this.querySelectorAll('[data-bagera-submit-selected]').forEach((button) => {
        button.addEventListener('click', () => this.submitSelected());
      });

      if (this.gallery && this.dots.length) {
        this.gallery.addEventListener('scroll', () => this.syncDots(), { passive: true });
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            const media = this.gallery.children[index];
            if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          });
        });
      }

      if (this.sticky && 'IntersectionObserver' in window) {
        const submit = this.querySelector('[data-bagera-desktop-submit]');
        if (submit) {
          const observer = new IntersectionObserver((entries) => {
            this.sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
          }, { threshold: 0 });
          observer.observe(submit);
        }
      }
    }

    selectOffer(offer) {
      const form = this.forms.find((item) => item.dataset.bageraProductForm === offer);
      if (!form) return;
      this.offer = offer;
      this.offerButtons.forEach((button) => {
        const selected = button.dataset.bageraOffer === offer;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', String(selected));
      });
      this.forms.forEach((item) => { item.hidden = item !== form; });
      this.updatePriceFromForm(form);
    }

    selectVariant(select) {
      const option = select.options[select.selectedIndex];
      const form = select.closest('[data-bagera-product-form]');
      const input = form && form.querySelector('input[name="id"]');
      if (input) input.value = select.value;
      if (form && form.dataset.bageraProductForm === this.offer) this.updatePrice(option);
    }

    updatePriceFromForm(form) {
      const select = form.querySelector('[data-bagera-variant]');
      if (select) {
        this.updatePrice(select.options[select.selectedIndex]);
        return;
      }
      this.updatePrice(form);
    }

    updatePrice(source) {
      const current = source.dataset.price || '';
      const compare = source.dataset.compare || '';
      const detail = source.dataset.detail || '';
      const note = source.dataset.note || '';
      if (this.price) this.price.textContent = current;
      if (this.compare) {
        this.compare.textContent = compare;
        this.compare.hidden = !compare;
      }
      if (this.saving) this.saving.textContent = note;
      if (this.stickyPrice) this.stickyPrice.textContent = current;
      if (this.stickyDetail) this.stickyDetail.textContent = detail;
    }

    submitSelected() {
      const wrapper = this.forms.find((item) => item.dataset.bageraProductForm === this.offer);
      const form = wrapper && wrapper.querySelector('form');
      if (form) form.requestSubmit();
    }

    syncDots() {
      const first = this.gallery.firstElementChild;
      if (!first) return;
      const width = first.getBoundingClientRect().width + 12;
      const active = Math.max(0, Math.min(this.dots.length - 1, Math.round(this.gallery.scrollLeft / width)));
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    }
  });
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-bagera-external-offer]');
  if (!trigger) return;
  const product = document.querySelector('bagera-product');
  if (!product) return;
  product.selectOffer(trigger.dataset.bageraExternalOffer);
  if (trigger.dataset.bageraAdd === 'true') product.submitSelected();
});

document.querySelectorAll('[data-bagera-faq]').forEach((list) => {
  list.querySelectorAll('details').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      list.querySelectorAll('details[open]').forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });
});

document.querySelectorAll('[data-bagera-header]').forEach((header) => {
  const toggle = header.querySelector('[data-bagera-menu-toggle]');
  const menu = header.querySelector('[data-bagera-mobile-menu]');
  if (!toggle || !menu) return;

  const setMenu = (open) => {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    menu.hidden = !open;
  };

  toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });
});

document.querySelectorAll('[data-bagera-placeholder-cta]').forEach((button) => {
  button.addEventListener('click', () => {
    const offer = document.querySelector('#offer');
    if (offer) offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});
